import { v4 as uuid } from 'uuid'

export interface IEODNotificationSettings {
  [restaurantId: string]: number
}

export interface IUserSetting {
  id: string
  userId: string
  eodNotificationSettings?: IEODNotificationSettings
}

export class UserSetting implements IUserSetting {
  public id: string
  public eodNotificationSettings?: IEODNotificationSettings

  constructor(public userId: string) {
    this.id = uuid()
  }

  public getEodNotificationDaysOfTheWeek(restaurantId: string) {
    if (!this.eodNotificationSettings) {
      return undefined
    }

    const eodBit = this.eodNotificationSettings[restaurantId]
    if (typeof eodBit !== 'number') {
      return undefined
    }

    return eodBit.toString(2)
    .padStart(7, '0')
    .split('')
    .reverse()
    .map(val => val === '1' ? true : false) as [boolean, boolean, boolean, boolean, boolean, boolean, boolean]
  }

  public setEodNotificationDaysOfTheWeek(
    restaurantId: string,
    daysOfTheWeek: [boolean, boolean, boolean, boolean, boolean, boolean, boolean]
  ) {
    if (!this.eodNotificationSettings) {
      this.eodNotificationSettings = {}
    }

    return this.eodNotificationSettings[restaurantId] = parseInt(
      daysOfTheWeek.reverse().map(val => val ? 1 : 0).join(''),
      2
    )
  }
}
